import { defaultCurrency, projectStyledName } from '../../constants'

/* eslint-disable max-len */
export const profile = {
  amountLess: 'Amount less than minimal',
  amountMax: 'Amount more than maximum',
  documentLengthMustBe: 'Document length must be',
  min: 'Min',
  max: 'Max',
  pendings: 'Pending',
  page: 'Page',
  game: 'Game',
  status: 'Status',
  win: 'Win',
  bet: 'Bet',
  date: 'Date',
  transaction: 'Transaction',
  gameType: 'Game type',
  provider: 'Provider',
  show: 'Show',
  from: 'From',
  before: 'Before',
  after: 'After',
  balanceBefore: 'Balance before',
  balanceAfter: 'Balance after',
  bonus: 'Bonus',
  results: 'Results',
  action: 'Action',
  to: 'To',
  genderMap: {
    Female: 'Female',
    Male: 'Male',
  },
  providerNames: {
    all: 'All',
    Sports: 'Sports',
    otherSlots: 'Other slots',
    amusnetlive: 'Amusnet',
  },
  spinHistory: 'Spin history',
  myProfile: 'My profile',
  profilePage: 'Profile page',

  promocode: 'Promocode',

  today: 'Today',
  yesterday: 'Yesterday',
  lastThreeDays: 'Last 3 days',
  lastWeek: 'Last week',
  custom: 'Custom',

  basicInformation: 'Basic information',
  email: 'Email address',
  login: 'Login',
  name: 'Name',
  dateOfRegistration: 'Date of registration',
  empty: 'empty *',
  required: 'required *',
  invalidEmail: 'invalid email *',
  m: 'Male',
  f: 'Female',
  countryLabel: 'Country (two-letter format)',

  amountBonusLess: `Amount bonus less 1 ${defaultCurrency}`,
  balanceMore: 'The transfer is available if the balance is less than $value',

  replenishment: 'Replenishment',
  backToProfile: 'Back to profile',
  myBonus: 'My Bonus',
  withdraw: 'Withdraw',
  withdrawable: 'Withdrawable',
  transactions: 'Transactions',
  kyc: 'KYC',
  limits: 'Limits',
  selfExclusion: 'Close an account',
  userInfo: 'Personal data',

  myAccount: 'My Account',
  accountId: 'Account ID',
  profile: 'Profile',
  account: 'Account',
  cashier: 'Cashier',
  history: 'History',
  settings: 'Settings',
  bonuses: 'Bonuses',
  pendingWithdrawals: 'Pending Withdrawals',
  balanceAdjustments: 'Balance Adjustments',
  newBonuses: 'New Bonuses',
  sportFreeSpins: 'Sport & Free Spins',
  startDate: 'Start Date',
  endDate: 'End Date',
  reload: 'Reload',
  count: 'Count',
  amount: 'Amount',
  lk: 'Your account',
  accountNum: 'Account number',

  DecreasedByOwner: 'Withdraw',
  IncreasedByOwner: 'Deposit',
  PersonalJackpot: 'Personal jackpot',

  gender: 'Gender',
  balance: 'Balance',
  bonusBalance: 'Bonus balance',
  fullName: 'Full name',
  currency: 'Currency',
  betslip: 'Betslip',
  id: 'Id',
  type: 'Type',
  description: 'Description',
  noData: 'No data show!',
  bonusHistory: 'Bonus history',
  cashbackHistory: 'Cashback history',
  additionalInfo: 'Additional info',
  yandex: 'Yandex (account number)',
  card: 'Card VISA/MASTER CARD (account number)',
  phone: 'Phone number',
  numberDocument: 'Document number',
  address: 'Registration Address',
  save: 'Save',
  savePassword: 'Save Password',
  cancel: 'Cancel',
  infoWasUpdated: 'Information successfully updated',
  changePassword: 'Change Password',
  changePasswordAdditional: 'Change your account password',
  yourPassword: 'Your password',
  enterPassword: 'Enter password',
  enterOldPassword: 'Current password',
  enterNewPassword: 'New password',
  repeatNewPassword: 'Repeat new password',
  topUp: 'TopUp account',
  withdrawalMoney: 'Withdrawal money',
  withdrawal: 'Withdrawal money',
  payHistory: 'Operations history',
  betHistory: 'Bet history',
  betsHistory: 'My bets',
  transactionsHistory: 'Transactions history',
  slotsHistory: 'Slots history',
  promotionalCodes: 'Activate promocode',
  logout: 'Logout',
  changedPassword: 'The password change is successful',
  changedPasswordDoNotMatch: 'Passwords do not match',
  promotionalCodesAdditional: 'Enter a promotional code to receive bonuses',
  betHistoryAdditional: 'All your recent bets',
  payHistoryAdditional: 'All operations that affected the change in balance',
  additionalInfoAdditional: 'Ability to add name, date of birth and phone number',
  ourCashiersAdditional: 'Addresses of our cash desks',
  ourCashiers: 'Our box office',
  country: 'Country',
  seriesDocument: 'A series of document',
  documentNumber: 'Document number',
  exit: 'Go out',
  exitAdditional: 'Log Out',
  registrationAddress: 'Registration address',
  firstName: 'First name',
  lastName: 'Last name',
  middleName: 'Middle name',
  birthDate: 'Birth date',
  city: 'City',
  phoneInfo: 'After the phone has been accepted, your login should not be registered earlier on the site.',
  dataIsNotEditable: 'Editing registration data is not available. Contact tech support.',
  personal: 'Personal',
  favoriteLinks: 'Favorite links',
  accountActivity: 'Account activity',
  personalDetails: 'Personal details',
  personalInformation: 'Personal information',
  currentPassword: 'Current Password',
  newPassword: 'New password',
  newPasswordConfirmation: 'New password(Confirm)',
  payment: 'Payments',
  contactDetails: 'Contact details',
  accountSettings: 'User account settings',
  username: 'Username',
  edit: 'Edit',
  reqForPasswordTitle: 'Requirements for valid password',
  reqForPassword1: 'must consist of at least 5, at most 40 characters',
  reqForPassword2: 'allowed special characters: !#$()@?{}|*+,^.-+&=%_:;~',
  reqForPassword3: 'cannot contain spaces',
  reqForPassword4: 'cannot be similar to or contain other personal data (e.g. first name, last name, username, etc.)',
  tips: 'Tips',
  tips1: 'longer and more complex passwords are securer',
  tips2: 'select password you do not use to log in to other online accounts',
  tips3: 'do not share password with others',
  passwordStrength: 'Password strength',
  title: 'Title',
  dateOfBirth: 'Date of birth (DD/MM/YYYY)',
  dateOfBirthPlaceholder: 'DD/MM/YYYY',
  street: 'Street',
  houseNumber: 'House number',
  zipCode: 'ZIP code',
  townCity: 'Town/City',
  contactLanguage: 'Contact language',
  mobilePhone: 'Mobile phone number',
  userData: 'User data',
  myBets: 'My bets',
  fundsTransfer: 'Funds transfer',
  informationForPassword: 'Information for password',
  questions: 'Questions',
  openGamingAccountTextOne: `How to open a BetGonzo gaming account? How to make a deposit or withdraw funds?
  In this section you will find answers to these and other frequently asked questions.`,
  openGamingAccountTextTwo: `However, if you haven't found the answer to your question, our support and
  customer service team will be happy to help!`,
  gameProfile: 'Gaming profile',
  responsibleGame: 'Responsible gaming',
  depositAndWithdrawal: 'Deposit & Withdrawal',
  callUs: 'Call us',
  contactUs: 'Contact us via Telegram',
  sendEmail: 'Send us an email',
  contactUsChat: 'Contact us via Whatsapp',
  cantFind: "Can't find what you are looking for?",
  realBalance: 'Real Balance',
  accountMenu: 'Account menu',

  termsConditionsContent: {
    generalTerms: {
      label: 'General Terms',
    },
    eligibilityUse: {
      label: `Eligibility to use ${projectStyledName} Services`,
    },
    calculationWinning: {
      label: 'Winnings and Calculation of Winnings',
    },
    userAccount: {
      label: 'User Account',
    },
    customerObligations: {
      label: 'The Customer’s obligations',
    },
    responsibleGaming: {
      label: 'Responsible Gaming',
    },
    casinoBets: {
      label: 'Casino Bets',
    },
    sportsBets: {
      label: 'Sports Bets',
    },
    bettingSoftware: {
      label: 'Betting Software Error',
    },
    privacyPolicy: {
      label: 'Privacy Policy',
    },
    settingLimit: {
      label: 'Setting up Limits',
    },
    complaints: {
      label: 'Complaints',
    },
    softwareProtection: {
      label: 'Software Protection',
    },
    limitationLiability: {
      label: 'Limitation of Liability',
    },
    breachesPenalties: {
      label: 'Breaches, Penalties and Termination',
    },
    severability: {
      label: 'Severability',
    },
    assignment: {
      label: 'Assignment',
    },
    problemGambiling: {
      label: 'Problem Gambling',
    },
  },

  example: 'Example',
  faq: {
    gameProfile: {
      item1: {
        heading: "Can't sign in?",
        text1: 'Your gaming profile may be blocked because The wrong password has been entered multiple times.',
        text2:
          "Don't worry, the account has been blocked for security purposes. Contact our support center using the Live Chat option or email us",
        text3:
          'Your profile may be blocked because the closing period you requested has not yet ended. In this case, our support center will not be able to restore your game profile and you will need to wait until the set closing time expires.',
      },
      item2: {
        heading: 'Need a break or want to close your gaming profile?',
        text1: "We're sorry you want to close your gaming profile, but we respect your choice.",
        text2: 'Contact our support center so that we can offer you a suitable option to close your profile.',
        text3: "Don't forget to enter your details: ID and username.",
      },
      item3: {
        heading: 'Why were you asked for documents?',
        text1:
          'For security reasons and based on legal requirements, we may ask you to send us documents to verify your gaming profile. This is a standard procedure during which we may request: a photo of an identity card (ID card or passport), bank account confirmation (payment order from your bank), a photo of a payment / credit card.',
        text2: 'You will receive an e-mail notification from us about which documents you need to provide.',
      },
    },
    paymentProfile: {
      item1: {
        heading: 'Deposit',
        text1: 'We offer fast deposit methods:',
        li1: `Deposit by bank card (Visa/MasterCard). Minimum deposit amount 5 ${defaultCurrency}`,
        li2: 'Deposit through available cryptocurrencies',
        text2:
          'If your deposit has not been added to your gaming profile, feel free to contact the support center and prepare a payment order in PDF format or a screenshot with all the details of the payment.',
        text3: 'Important! Deposits can only be made from your credit cards and bank accounts registered in your name.',
      },
      item2: {
        heading: 'Withdrawal',
        text1:
          'Payment can be requested to the card number, which is indicated in the withdrawal request form. Or to the wallet of one of the cryptocurrencies available for withdrawal. Funds will be lost if the wrong wallet is specified.',
        text2: 'Payments are confirmed from our side within the next hour after your request.',
        text3:
          'Bank funds are received within 5 minutes after confirmation from our side. Due to various circumstances, the payment may be delayed.',
        text4: `The minimum amount you can request is 10 ${defaultCurrency}.`,
        // text5: 'If you have any questions, please contact us via email support@betgonzo.com',
        text5: '',
      },
      item3: {
        heading: 'Why was your payout cancelled?',
        text1: 'It may take up to 24 hours for us to confirm the payment.',
        text2:
          'We may contact you by e-mail and request some documents to verify your gaming profile. If you have been asked for documents, you will need to wait while we check them and confirm the requested payment. This procedure may take up to 24 hours.',
        text3:
          'You have the opportunity to contact our support center if you have additional questions regarding the verification of documents.',
      },
      item4: {
        heading: 'Closed loop principle',
        text1: 'We use a closed loop principle that applies to payouts in the following ways:',
        li1text1: 'Withdrawal must be requested by the method used for the last deposit.',
        li1text2: 'Last deposit from a Visa bank card → payout to a Visa bank card',
        li2text1:
          'If the player has multiple payout methods available, then the payout can be split between the methods as follows: the player must claim the full amount of the deposit from which the winnings were received, for the deposit method last used before winning. The rest of the amount can be requested in any other verified way.',
        li2text2:
          '€100 winnings received from a deposit of €20 with a Visa bank card → 1. payout to a Visa bank card in the amount of €20 (deposit amount) → 2. payout to a cryptocurrency wallet €80 (balance of winnings)',
        li3text1: 'We reserve the right to decide which payout method should be used.',
      },
    },
  },

  send: 'Send',
  acceptedFormats: 'Accepted formats',
  maximumSize: 'Maximum size',
  'invalid-size': 'The file size does not meet the limits',
  'invalid-type': 'The type of file is invalid',
  pleaseSelectFile: 'Please select a file',
  kycSendedSuccess: 'The file have been sent successfully',
  exchangeBonusBalance: 'Exchange bonus balance',
  exchangeBonus: 'Exchange bonus',
  bonusPromotions: 'Bonus promotions',
  deposit: 'Deposit',
  message: 'Message',
  submit: 'Submit',
  fillSupportForm: 'Please fill out the form below and we will contact you as soon as possible.',

  sftBetStatuses: {
    Wait: 'Wait',
    Lost: 'Lost',
    Return: 'Returned',
    Win: 'Win',
    CashOut: 'Sold',
  },
  promotions: 'Promotions',
  activePromotions: 'Active promotions',
  yourActivePromotions: 'Your active promotions',
  available: 'Available',
  yourAvailablePromotions: 'Your available promotions',
  completed: 'Completed',
  yourCompletedPromotions: 'Your completed promotions',
  expired: 'Expired',
  yourExpiredPromotions: 'Your expired promotions',

  uploadPassport: 'Upload Passport',
  uploadPassportImage: 'Upload images of your passport (.jpg or .png)',
  pleaseNotRedact: `Please, do not redact, watermark or otherwise obscure any part of your document.
  This will help ensure we can verify your document as quickly and as accurately as possible.`,
  uploadDriveLicense: 'Upload Drivers License',
  uploadDriveLicenseImage: 'Upload images of your driver’s license (.jpg or .png)',
  uploadNationalIDCard: 'Upload National ID Card',
  uploadNationalIDCardImage: 'Upload images of your national ID card (.jpg or .png)',
  passport: 'Passport',
  driverLicense: 'Drivers License',
  nationalId: 'National ID Card',
  front: 'Front',

  couldVerifyText: `We couldn't verify your document.
	Please make sure all the information in your photo is legible or try another document.`,
  selectIdType: 'Select ID type',
  financialRegulations: 'Financial regulations require us to verify your identity',
  documentUploadText: `Your photo ID and actions captured during the ID verification process may constitute biometric data.
  Please see our Privcy Policy for more information about how we store and use your biometric data.
  Select ID type proceed`,
  documentWasNotLoaded: 'The document was not loaded',

  tryAgain: 'Try again',
  uploadDocuments: 'Upload documents',
  uploadYourDocuments: 'Upload your documents',
  verifiedText: 'Document verification completed successfully',
  pendingText: 'Your documents are being verified',
  documentsRejected: 'The documents were rejected',
  reason: 'Reason',
  verifyDocs: 'Verify docs',
  goBack: 'Go back',
  back: 'Back',
  back2: 'Back',
  kycVerification: 'KYC Verification',

  verifyTerms1: 'All four corners of the document are visible',
  verifyTerms2: 'The date of your document must not be more than 10 years old',
  verifyTerms3: 'Include a copy of the front and back',
  verifyTerms4: 'All details match the personal information in your account',
  verifyTerms5: 'All details are visible and nothing has been covered/changed/cut',

  verifyYouText: `To verify that you are you, upload a government issued/approved photo document
  (such as an ID-card or a passport). We typically review your documents within 48 hours. Sometimes, due to high demand, there may be delays in analysis. Before uploading, make sure`,
  fileIsTooBig: 'The file is too big',
  fileTypeInvalid: 'Invalid file type. Should be png, jpg or jpeg image.',
  dragDropOrClick: 'Drag & drop or click to upload',
}
